import { DIFFICULTY_LEVELS, QUESTION_TYPES } from '../questionTypes';

// 30 Preguntas del Músculo Pectoral Mayor
// 10 Básicas + 10 Generales + 10 Complejas

export const pectoralMayorQuestions = [
  
  // ========== NIVEL BÁSICO (10) ==========
  
  {
    id: 10121,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Cuántas porciones tiene el músculo pectoral mayor?",
    options: ["Una", "Dos", "Tres", "Cuatro"],
    correctAnswer: 1,
    explanation: "El pectoral mayor tiene tres porciones: clavicular (superior), esternocostal (media) y abdominal (inferior). Esta disposición en abanico le permite múltiples acciones sobre el hombro. Es el músculo más superficial del tórax anterior y uno de los más fuertes del hombro."
  },
  
  {
    id: 10122,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se inserta el tendón del pectoral mayor?",
    options: [
      "Tubérculo mayor del húmero",
      "Tubérculo menor del húmero",
      "Surco intertubercular del húmero",
      "Cóndilo humeral"
    ],
    correctAnswer: 2,
    explanation: "El tendón del pectoral mayor se inserta en el surco intertubercular (surco bicipital) del húmero. Esta inserción permite su acción como aductor y rotador interno del hombro. El tendón forma el límite lateral del surco."
  },
  
  {
    id: 10123,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cuál es la acción principal de la porción clavicular del pectoral mayor?",
    options: [
      "Flexión del hombro",
      "Abducción del hombro",
      "Adducción del hombro",
      "Extensión del hombro"
    ],
    correctAnswer: 0,
    explanation: "La porción clavicular del pectoral mayor es la principal flexora del hombro. Actúa especialmente cuando el brazo está en posición neutra o aducción. Es antagonista de los músculos posteriores del hombro como el trapecio."
  },
  
  {
    id: 10124,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Qué nervios inervan al pectoral mayor?",
    options: [
      "Nervio pectoral medial",
      "Nervio pectoral lateral",
      "Ambos nervios pectorales",
      "Nervio torácico largo"
    ],
    correctAnswer: 2,
    explanation: "El pectoral mayor recibe inervación dual de los nervios pectorales medial (C8-T1) y lateral (C5-C7). Esta doble inervación explica por qué la parálisis completa del pectoral mayor es rara, requiriendo lesión de ambos nervios."
  },
  
  {
    id: 10125,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué arteria irriga principalmente al pectoral mayor?",
    options: [
      "Arteria torácica interna",
      "Arteria toracoacromial",
      "Arteria axilar",
      "Arteria subclavia"
    ],
    correctAnswer: 1,
    explanation: "La arteria toracoacromial, rama de la arteria axilar, irriga principalmente al pectoral mayor a través de su rama pectoral. También recibe irrigación de las arterias intercostales anteriores y perforantes de la arteria torácica interna."
  },
  
  {
    id: 10126,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué músculo se encuentra profundo al pectoral mayor?",
    options: [
      "Pectoral menor",
      "Serrato anterior",
      "Subclavio",
      "Todos los anteriores"
    ],
    correctAnswer: 3,
    explanation: "Profundo al pectoral mayor se encuentran el pectoral menor (que forma el piso de la axila), el subclavio (que pasa entre pectoral mayor y menor) y porciones del serrato anterior. Esta disposición explica la vulnerabilidad de estos músculos en lesiones del hombro."
  },
  
  {
    id: 10127,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Qué significa que el pectoral mayor es un músculo multipenniforme?",
    options: [
      "Tiene múltiples inserciones",
      "Tiene múltiples orígenes",
      "Sus fibras se disponen en penniforme",
      "Tiene múltiples funciones"
    ],
    correctAnswer: 1,
    explanation: "El pectoral mayor es multipenniforme porque tiene múltiples orígenes (clavícula, esternón, cartílagos costales y aponeurosis abdominal) que convergen en una sola inserción (surco intertubercular). Esta disposición permite una fuerza considerable en múltiples direcciones."
  },
  
  {
    id: 10128,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se origina la porción esternocostal del pectoral mayor?",
    options: [
      "Tercio medial de la clavícula",
      "Borde lateral del esternón",
      "Cartílagos de las primeras 6 costillas",
      "Aponeurosis del oblicuo externo"
    ],
    correctAnswer: 2,
    explanation: "La porción esternocostal del pectoral mayor se origina en los cartílagos costales de las primeras seis costillas y en el borde lateral del esternón. Esta amplia inserción torácica le da su forma característica de abanico."
  },
  
  {
    id: 10129,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Qué acción realiza la porción abdominal del pectoral mayor?",
    options: [
      "Depresión del hombro",
      "Elevación del hombro",
      "Rotación interna del hombro",
      "Todas las anteriores"
    ],
    correctAnswer: 0,
    explanation: "La porción abdominal del pectoral mayor actúa como depresor del hombro. Es especialmente activa en movimientos como bajar objetos pesados o hacer lagartijas. Su origen en la aponeurosis abdominal explica su función depresora."
  },
  
  {
    id: 10130,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Por qué el pectoral mayor es importante en la respiración?",
    options: [
      "Es un músculo respiratorio accesorio",
      "Ayuda en la inspiración forzada",
      "Fija las costillas durante la respiración",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "El pectoral mayor actúa como músculo respiratorio accesorio durante la inspiración forzada, ayudando a elevar las costillas. También fija las costillas durante movimientos del brazo, previniendo su movimiento paradójico durante la respiración."
  },
  
  // ========== NIVEL GENERAL (10) ==========
  
  {
    id: 10131,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cómo contribuye el pectoral mayor a la rotación interna del hombro?",
    options: [
      "Todas las porciones contribuyen por igual",
      "Principalmente la porción clavicular",
      "Principalmente la porción abdominal",
      "No contribuye a la rotación interna"
    ],
    correctAnswer: 0,
    explanation: "Todas las porciones del pectoral mayor contribuyen a la rotación interna del hombro, pero la porción inferior (abdominal) es la más potente. Esta acción es importante en movimientos como lanzar, golpear o abrazar. La rotación interna es máxima con el brazo en 90° de abducción."
  },
  
  {
    id: 10132,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué músculos actúan como sinergistas del pectoral mayor en la aducción del hombro?",
    options: [
      "Dorsal ancho y redondo mayor",
      "Deltoides y supraespinoso",
      "Trapecio y elevador de la escápula",
      "Romboídes y trapecio"
    ],
    correctAnswer: 0,
    explanation: "Los sinergistas del pectoral mayor en la aducción del hombro son el dorsal ancho y el redondo mayor. Estos tres músculos forman el 'músculo del abrazo', actuando coordinadamente para aducción y rotación interna. El dorsal ancho es el más potente."
  },
  
  {
    id: 10133,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué rama específica de la arteria toracoacromial irriga al pectoral mayor?",
    options: [
      "Rama acromial",
      "Rama clavicular",
      "Rama deltoidea",
      "Rama pectoral"
    ],
    correctAnswer: 3,
    explanation: "La rama pectoral de la arteria toracoacromial irriga específicamente el pectoral mayor. Esta arteria sale del pedículo toracoacromial y desciende entre el pectoral mayor y menor, formando anastomosis importantes con la arteria torácica interna."
  },
  
  {
    id: 10134,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Cómo se distribuye la inervación de los nervios pectorales?",
    options: [
      "Nervio lateral inerva porción clavicular, medial inerva el resto",
      "Nervio medial inerva porción clavicular, lateral inerva el resto",
      "Inervación superpuesta sin distribución específica",
      "Solo nervio lateral inerva todo el músculo"
    ],
    correctAnswer: 0,
    explanation: "El nervio pectoral lateral inerva principalmente la porción clavicular, mientras que el nervio pectoral medial inerva las porciones esternocostal y abdominal. Esta distribución explica por qué lesiones específicas pueden afectar selectivamente porciones del pectoral mayor."
  },
  
  {
    id: 10135,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VARIANTE,
    question: "¿Cuál es la variante anatómica más común del pectoral mayor?",
    options: [
      "Ausencia congénita",
      "Cabeza esternocostal accesoria",
      "Inserción doble en el húmero",
      "Fusión con pectoral menor"
    ],
    correctAnswer: 1,
    explanation: "La presencia de una cabeza esternocostal accesoria es la variante más común del pectoral mayor, ocurriendo en 5-8% de la población. Esta cabeza adicional se origina de la fascia del recto abdominal y se inserta con el tendón principal, aumentando la fuerza del músculo."
  },
  
  {
    id: 10136,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué test clínico evalúa específicamente la función del pectoral mayor?",
    options: [
      "Test de aducción resistida",
      "Test de elevación escapular",
      "Test de rotación externa",
      "Test de abducción"
    ],
    correctAnswer: 0,
    explanation: "El test de aducción resistida evalúa la integridad del pectoral mayor. El paciente aduce el brazo contra resistencia aplicada en la cara medial del brazo. Debilidad indica lesión del músculo o de los nervios pectorales. Es positivo en rupturas del pectoral mayor."
  },
  
  {
    id: 10137,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.EMBRIOLOGIA,
    question: "¿De qué masa muscular embrionaria se desarrolla el pectoral mayor?",
    options: [
      "Masa pectoral ventral",
      "Masa deltoidea dorsal",
      "Masa flexora ventral",
      "Masa extensora dorsal"
    ],
    correctAnswer: 0,
    explanation: "El pectoral mayor se desarrolla de la masa muscular pectoral ventral del miembro superior, alrededor de la 5-6 semana de gestación. Esta masa da origen también al pectoral menor y porciones del deltoides, explicando su inervación común por nervios pectorales."
  },
  
  {
    id: 10138,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.HISTOLOGIA,
    question: "¿Qué proporción aproximada de fibras musculares tiene el pectoral mayor?",
    options: [
      "90% fibras tipo I",
      "70% fibras tipo II",
      "50% tipo I, 50% tipo II",
      "30% tipo I, 70% tipo II"
    ],
    correctAnswer: 2,
    explanation: "El pectoral mayor tiene distribución equilibrada de fibras musculares (50% tipo I, 50% tipo II), adaptado para movimientos que requieren fuerza y resistencia. Las porciones clavicular y abdominal tienen ligeramente más fibras tipo II para movimientos potentes."
  },
  
  {
    id: 10139,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué espacio anatómico se encuentra entre el pectoral mayor y menor?",
    options: [
      "Espacio axilar",
      "Espacio costoclavicular",
      "Espacio interpectoral",
      "Espacio subclavio"
    ],
    correctAnswer: 2,
    explanation: "El espacio interpectoral (espacio de los dos pectorales) contiene tejido areolar, vasos y nervios. Es importante en disecciones quirúrgicas del tórax anterior. El nervio pectoral lateral y la arteria toracoacromial pasan por este espacio."
  },
  
  {
    id: 10140,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Por qué el pectoral mayor es menos eficiente en flexión cuando el brazo está extendido?",
    options: [
      "Por la contracción del dorsal ancho",
      "Por el ángulo de tracción del tendón",
      "Por la posición del hombro",
      "Por la estabilización escapular"
    ],
    correctAnswer: 1,
    explanation: "Con el brazo extendido, el ángulo de tracción del pectoral mayor sobre el húmero es menos favorable, disminuyendo su eficiencia como flexor. La máxima eficiencia ocurre cuando el brazo forma un ángulo de 60-90° con el torso, optimizando la ventaja mecánica."
  },
  
  // ========== NIVEL COMPLEJO (10) ==========
  
  {
    id: 10141,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con antecedente de levantamiento de pesas presenta 'signo del botón' en ecografía. ¿Qué lesión tiene?",
    options: [
      "Ruptura completa del pectoral mayor",
      "Tendinitis del pectoral mayor",
      "Ruptura del pectoral menor",
      "Bursitis interpectoral"
    ],
    correctAnswer: 0,
    explanation: "El 'signo del botón' en ecografía indica ruptura completa del tendón del pectoral mayor. Se observa retracción del tendón roto que se 'abotona' contra el músculo. Es común en levantadores de pesas durante press de banca. Requiere reparación quirúrgica para restaurar fuerza."
  },
  
  {
    id: 10142,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Paciente con dolor torácico anterior y debilidad para cruzar los brazos. ¿Qué patología sugiere?",
    options: [
      "Tendinitis del pectoral mayor",
      "Síndrome del pectoralis minor",
      "Ruptura del pectoral mayor",
      "Compresión del plexo braquial"
    ],
    correctAnswer: 1,
    explanation: "El síndrome del pectoralis minor (espacio interpectoral estrecho) causa dolor torácico anterior, debilidad para cruzar los brazos y parestesias en el brazo. El pectoral menor hipertónico comprime el plexo braquial y vasos subclavios. Se trata con fisioterapia y ocasionalmente sección quirúrgica del pectoral menor."
  },
  
  {
    id: 10143,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué técnica se utiliza para reparar una ruptura aguda del tendón del pectoral mayor?",
    options: [
      "Sutura directa con anclas transóseas",
      "Transferencia tendinosa",
      "Reconstrucción con autoinjerto",
      "Liberación y avance tendinoso"
    ],
    correctAnswer: 0,
    explanation: "La ruptura aguda del tendón del pectoral mayor se repara con sutura directa reforzada con anclas transóseas en el surco intertubercular. La reparación temprana (<3 semanas) tiene mejor pronóstico funcional. Las rupturas crónicas requieren técnicas más complejas como injertos tendinosos."
  },
  
  {
    id: 10144,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En RM del hombro, ¿qué hallazgo confirma ruptura completa del pectoral mayor?",
    options: [
      "Engrosamiento difuso del músculo",
      "Ausencia del tendón en el surco intertubercular",
      "Aumento de señal en T2-STIR",
      "Calcificaciones intratendinosas"
    ],
    correctAnswer: 1,
    explanation: "La ruptura completa del pectoral mayor muestra ausencia del tendón en el surco intertubercular del húmero, con retracción proximal del músculo. La porción clavicular se retrac hasta el nivel clavicular, mientras que las porciones esternocostal y abdominal se retracen menos. Es patognomónico."
  },
  
  {
    id: 10145,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué complicación puede causar la contractura del pectoral mayor?",
    options: [
      "Escápula alada",
      "Síndrome del desfiladero torácico",
      "Limitación de la rotación externa",
      "Todas las anteriores"
    ],
    correctAnswer: 2,
    explanation: "La contractura del pectoral mayor limita la rotación externa del hombro y puede contribuir al síndrome del desfiladero torácico. En deportistas, especialmente lanzadores, puede causar impingement subacromial secundario. El estiramiento y liberación quirúrgica pueden ser necesarios."
  },
  
  {
    id: 10146,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con mastectomía radical presenta linfedema del brazo. ¿Qué estructura se lesionó durante la cirugía?",
    options: [
      "Nervios pectorales",
      "Ganglios linfáticos axilares",
      "Arteria toracoacromial",
      "Músculo pectoral menor"
    ],
    correctAnswer: 1,
    explanation: "La mastectomía radical incluye disección de los ganglios linfáticos axilares (niveles I-III), lo que puede causar linfedema por interrupción del drenaje linfático. Los ganglios axilares drenan la mama, pared torácica y extremidad superior. La reconstrucción con colgajo miocutáneo de dorsal ancho preserva parte de la función."
  },
  
  {
    id: 10147,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Evaluación isocinética muestra déficit selectivo de aducción concéntrica del hombro. ¿Qué porción del pectoral mayor está afectada?",
    options: [
      "Porción clavicular",
      "Porción esternocostal",
      "Porción abdominal",
      "Todas las porciones"
    ],
    correctAnswer: 1,
    explanation: "La porción esternocostal del pectoral mayor es la más activa en aducción concéntrica del hombro. Es la porción más grande y proporciona la mayor fuerza. La evaluación isocinética permite cuantificar la contribución específica de cada porción del músculo."
  },
  
  {
    id: 10148,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué abordaje se utiliza para biopsia del pectoral mayor?",
    options: [
      "Abordaje infraclavicular",
      "Abordaje parasternal",
      "Abordaje deltopectoral",
      "Abordaje axilar"
    ],
    correctAnswer: 2,
    explanation: "El abordaje deltopectoral permite acceso directo al pectoral mayor entre el deltoides y pectoral mayor. Es útil para biopsia muscular en sospecha de miopatías o enfermedades sistémicas. Evita estructuras vasculonerviosas importantes y permite buena exposición."
  },
  
  {
    id: 10149,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En ecografía del tórax anterior, ¿qué maniobra confirma contractura del pectoral mayor?",
    options: [
      "Abducción pasiva del hombro",
      "Rotación interna resistida",
      "Compresión directa del músculo",
      "Movimiento de elevación escapular"
    ],
    correctAnswer: 0,
    explanation: "La ecografía durante abducción pasiva del hombro evalúa la contractura del pectoral mayor. En casos de contractura, se observa limitación del deslizamiento muscular normal y engrosamiento fascial. Es útil para diferenciar contractura de otras causas de rigidez del hombro."
  },
  
  {
    id: 10150,
    muscle: 'pectoral_mayor',
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "Atleta con hipertrofia compensatoria del pectoral mayor post-lesión del manguito rotador. ¿Qué explica este hallazgo?",
    options: [
      "Adaptación por sobrecarga",
      "Hipertrofia cruzada",
      "Efecto Wolff",
      "Todas las anteriores"
    ],
    correctAnswer: 0,
    explanation: "La hipertrofia compensatoria del pectoral mayor ocurre por sobrecarga funcional cuando el manguito rotador está lesionado. El pectoral mayor compensa la pérdida de fuerza de los rotadores externos, especialmente en abducción. La rehabilitación debe incluir fortalecimiento equilibrado para prevenir desequilibrios musculares."
  }
];
